import React from "react";
import { useRouter } from "next/router";

import { FlexContainer } from "@/components/Atoms/Box";
import MainTemplate from "@/components/Templates/MainTemplate";
import Breadcrumb from "./Breadcrumb";
import PageTitle from "./PageTitle";
import QuestionItem from "./QuestionItem";
import ConditionItem from "./ConditionItem";
import PageHeader from "./PageHeader";

import { ConditionList, PageWrapper, QuestionList } from "./style";

import data from "./data";

const YogaFAQPage = () => {
  const { slug: section } = useRouter().query;

  const { pageTitle, conditions } = data || {};

  const sectionData = data?.conditions?.[0]?.sections?.find(
    (s) => s?.url === section
  ); // TODO: Update this and remove Hard coded zeroth Index

  const { title, questions } = sectionData || {};

  return (
    <MainTemplate hideFooter hideLinks hideRibbon>
      <PageHeader />
      {section && <Breadcrumb section={sectionData.title} />}
      <FlexContainer>
        <PageWrapper>
          <PageTitle title={section ? title : pageTitle} />
          {section ? (
            <QuestionList>
              {questions?.map((question) => (
                <QuestionItem key={question.question} {...question} />
              ))}
            </QuestionList>
          ) : (
            <ConditionList>
              {conditions?.map((condition) => (
                <ConditionItem key={condition.conditionTitle} {...condition} />
              ))}
            </ConditionList>
          )}
        </PageWrapper>
      </FlexContainer>
    </MainTemplate>
  );
};

export default YogaFAQPage;
